import React from 'react';

const termsData = [
  {
    title: 'User Responsibilities',
    content: [
      'Users must provide truthful, verifiable information. Buyers and sellers are bound by our auction rules and platform code of conduct.'
    ]
  },
  {
    title: 'Auction Rules',
    content: [
      'All bids are binding.',
      'No bid withdrawal within the last 24 hours of an auction.',
      'Reserve prices may apply and are confidential.'
    ]
  },
  {
    title: 'Payment Terms',
    content: [
      'Payment must be completed within 5 business days via bank transfer or approved methods.',
      'A late fee of 2% per week applies after due date.'
    ]
  },
  {
    title: 'Disclaimers',
    content: [
      'All items are sold "as is."',
      'While efforts are made to confirm authenticity, buyers must conduct their own due diligence.',
      'The Auction House is not liable for errors in description caused by incomplete provenance.'
    ]
  },
  {
    title: 'Ownership Transfer',
    content: [
      'Title transfers to the buyer only upon full payment clearance. Delivery and insurance thereafter become the buyer\'s responsibility.'
    ]
  }
];

function TermsComp() {
  return (
    <section className="sec_pd mb-5 mt-5">
      <h3 className="text-black mb-4">Terms & Conditions</h3>
      {termsData.map((section, index) => (
        <div key={index} className="mb-4">
          <p className="text-black fw-bold mt-4">{index + 1}. {section.title}</p>
          <div className="text-muted">
            {section.content.map((line, i) => (
              <p key={i} className="mb-1">{line}</p>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}

export default TermsComp;
